import { getErrorMessage } from '../utils/util.errors';
import services from '../config/services';
import axios from 'axios';
import {
	GET_BY_INNER_BRANCH_ID_CENTER_CONFIGURATION,
	UPDATE_CENTER_CONFIGURATION,
	GET_ERRORS

} from './types';

const URL_GET_CENTER_CONFIGURATION_BY_INNER_BRANCH_ID = process.env.REACT_APP_API_URL + services.getCenterConfigurationByInnerBranchId;
const URL_UPDATE_CENTER_CONFIGURATION                 = process.env.REACT_APP_API_URL + services.updateCenterConfiguration;

export const getByInnerBranchId = (innerBranchId) => dispatch => {
	const url = URL_GET_CENTER_CONFIGURATION_BY_INNER_BRANCH_ID + '?innerBranchId=' + innerBranchId;
	axios
		.get(url)
		.then(res => {
			dispatch({
				type: GET_BY_INNER_BRANCH_ID_CENTER_CONFIGURATION,
				payload: res.data.result
			})
		})
		.catch(error => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)
			})
		});
};

export const updateCenterConfiguration = (centerConfiguration) => dispatch => {
	axios
		.put(URL_UPDATE_CENTER_CONFIGURATION, centerConfiguration)
		.then(res => {
			dispatch({
				type: UPDATE_CENTER_CONFIGURATION,
				payload: res.result
			})

		})
		.catch(error => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)
			})
		});
}
